/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Demoneu_Philologie17Inputs */

const en__field_enum_demoneu_philologie17 = /** @type {(inputs: _Field_Enum_Demoneu_Philologie17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 - Neuere Philologien`)
};

const de__field_enum_demoneu_philologie17 = /** @type {(inputs: _Field_Enum_Demoneu_Philologie17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 - Neuere Philologien`)
};

/**
* | output |
* | --- |
* | "10 - Neuere Philologien" |
*
* @param {_Field_Enum_Demoneu_Philologie17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_demoneu_philologie17 = /** @type {((inputs?: _Field_Enum_Demoneu_Philologie17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Demoneu_Philologie17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_demoneu_philologie17(inputs)
	return de__field_enum_demoneu_philologie17(inputs)
});
export { _field_enum_demoneu_philologie17 as "_field_enum_DEMONEU_PHILOLOGIE" }